import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class PermissionModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (PermissionModel._instance == null) PermissionModel._instance = new PermissionModel(authManager);
        return PermissionModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/permissions', 'core/permissions/codelist');

        this.entityName = 'core.Permission';
        this.privileges = {
            create: [["#admin"]],
            read: [["#admin"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Privilege';
        this.setLabel = 'Privileges';

        this.browser = {
            name: 'default-core-permission-browser',
            moduleName: 'default-core-permission-browser',
            moduleTitle: 'Privileges',
            moduleStateSlotName: 'default-core-permission-browser',
        };

        this.editor = {
            name: 'default-core-permission-editor',
            moduleName: 'default-core-permission-editor',
            moduleTitle: 'Privilege',
            moduleStateSlotName: 'default-core-permission-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
